module.exports = "img/cancel.2e55c0d.png";